import React, { useState } from "react";
import { Button } from "@mui/material";
import { styled } from "@mui/system";
import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";
//IDOGAN;449733;25042025
interface ByzMuiSendButtonProps {
  onClick: () => void;
  disabled?: boolean;
  sx?: any;
}

const StyledSendButton = styled(Button)(() => ({
  borderRadius: "4px",              
  padding: "4px 20px",
  letterSpacing: "0px",
  textTransform: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  border: "1px solid #2979C3",      
  backgroundColor: "#63B4FF33",   
  color: "#2979C3",                 
  "&:hover": {
    backgroundColor: "#2979C3",     
    color: "#fff",                  
  },
}));

const ByzMuiSendButton: React.FC<ByzMuiSendButtonProps> = ({
  onClick,
  disabled = false,
  sx,
}) => {
  const { t } = useTranslate();
  const [hover, setHover] = useState(false);

  return (
    <StyledSendButton
      
      disabled={disabled}
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      sx={sx}
    >
      <ByzMuiTypography
        fontWeight={400}
        marginLeft="True"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {t("buttons.send")}
      </ByzMuiTypography>
    </StyledSendButton>
  );
};

export default ByzMuiSendButton;
